<template>
  <div >
    <div class="d-flex flex-column" style="height:100%;background:#f7f7f7" id="page2">
      <div class="header"><v-header class="header"></v-header></div>


    	<div class="d-flex justify-content-center mar-top20">
        <!-- 日记详情左边部分 -->
        <div class="content-left bgc-ffffff align-self-start pad-bottom30">
          <!-- <div>
            <img :src="showImg" style="width:600px;height:600px;margin-bottom: 10px" class="imgFit"/>
            <div style="overflow-x: scroll" class="d-flex justify-content-center">
              <div v-for="(item,index) in diary.diaryImgs" class="pad-left10" >
                <img :src="item.ip+item.url" class="listImg imgFit" :class="showImgIndex==index?'selectImgStyle':'border6'" v-on:click="selectImg(index)"/>
              </div>
            </div>
          </div> -->
          <div class="top-img">
            <div class="swiper_box" style="height:100%;width:100%">
            	<swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
            		<swiper-slide class="slide-1" v-for="(item,index) in diary.diaryImgs" :key="index">
            			<img :src="item.ip+item.url" style="height:100%;width:100%"  class="imgFit">
            		</swiper-slide>
                <div class="swiper-button-prev"></div><!--左箭头。如果放置在swiper外面，需要自定义样式。-->
                <div class="swiper-button-next"></div><!--右箭头。如果放置在swiper外面，需要自定义样式。-->
            	</swiper>
            	<swiper style="margin-top:10px;" :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
            		<swiper-slide class="slide" v-for="(item,index) in diary.diaryImgs" :key="index">
            			<!-- <div class="imgItem"> -->
            				<img style="width:100%;height:100%;border-radius: 10px;" :src="item.ip+item.url" class="imgFit">
            			<!-- </div> -->
            		</swiper-slide>
            	</swiper>
            </div>
          </div>

          <div>
            <div style="margin:0 30px;border-bottom:1px solid #c1c1c1;padding:20px 0" class="fz16">{{diary.secondTitle}}</div>
            <div style="background:#f1f1f1;width:84%;margin:30px auto;padding:10px 20px 10px 10px;border-radius: 6px;" class="d-flex align-items-center">
              <img :src="diary.circleImg" style="width:60px;height:60px;border-radius: 3px;" class="imgFit"/>
              <div class="mar-left15 flex-fill">
                <div class="fz16 font-weight-bold">{{diary.circleTile}}</div>
                <div class="mar-top10">{{diary.clockNum}}篇日记&nbsp;{{diary.joinNum}}人参与</div>
              </div>
              <div style="height:40px;width:90px;text-align: center;line-height: 40px;font-size:15px;border-radius:6px;background:#ff9a2e" class="c-ffffff" v-on:click="lookMore(layerShow)">点击参加</div>
            </div>

            <div style="padding:25px 0 25px 30px" class="d-flex align-items-center" >
              <img src="../../assets/img/index/like.png" style="width:15px;height:15px" class="mar-right5"/>
              {{diary.likeNum}}&nbsp;赞
              <img src="../../assets/img/index/comment1.png" style="width:15px;height:15px" class="mar-left20 mar-right5"/>
              {{diary.commentList.length}}&nbsp;评论
            </div>
            <div class="pad-left30">发布于{{diary.releaseDate}}</div>
            <div class="pad-left30 mar-top25 font-weight-bold fz18">评论</div>
            <div class="mar-top15">
              <div v-for="item in diary.commentList">
                <div class="mar-left30">
                  <div class="d-flex align-items-center pad-right30 ">
                    <img :src="item.avatarpath?item.avatarip+item.avatarpath:item.avatarurl" style="width:50px;height:50px;border-radius: 50%;" class="imgFit"/>
                    <div class="mar-left10 flex-fill">
                      <div class="fz14">{{item.nickname}}</div>
                      <div class="fz12 mar-top5">{{item.createdate}}</div>
                    </div>
                    <!-- <div class="d-flex align-items-center">
                      <img src="../../assets/img/index/like.png" style="width:15px;height:15px"/>&nbsp;赞
                      <img src="../../assets/img/index/comment1.png" class="mar-left20" style="width:15px;height:15px"/>&nbsp;回复
                    </div> -->
                  </div>
                </div>
                <div class="mar-left90 pad-top5 mar-bottom15" style="width: 400px;">{{item.text}}</div>
              </div>
            </div>

            <div class="mar-left30 mar-right30" style="height:40px;text-align: center;line-height: 40px;border-radius: 5px;background:#f7f7f7;color:#ff9a2e" v-on:click="lookMore(layerShow)">查看更多评论</div>

          </div>
        </div>

        <!-- 日记详情右边部分 -->
        <div class="content-right mar-left35 bgc-ffffff align-self-start rightContent" style="width:350px;">
          <div class="pad-bottom15" >
            <div class="mar-left15 pad-top20 pad-bottom20 mar-right15 fz16 font-weight-bold" style="border-bottom:1px solid #c1c1c1 fz16 font-weight-bold">日记作者</div>
            <div class="pad-left15">
              <img :src="diary.headUrl" style="width:50px;height:50px;border:1px solid #c3c3c3;border-radius: 50%;"/>
              <div class="mar-top10 fz14">{{diary.nickname}}</div>
            </div>
          </div>
          <div style="height:10px;background:#f7f7f7" ></div>
          <div style="height:550px;overflow-y: scroll;"  >
             <div class="mar-left15 pad-top20 mar-right15 fz16 font-weight-bold" style="border-bottom:1px solid #c1c1c1 fz16 font-weight-bold">相关日记</div>
             <div class="d-flex align-items-center pad-left15 pad-right15 mar-top20 mar-bottom15" v-for="item in list" v-on:click="toDetail(item.id)">
               <img :src="item.src" class="imgFit" style="width:65px;height:65px;border-radius: 5px;"/>
               <div class="mar-left10">
                 <div class="twoLine">{{item.text}}</div>
                 <div class="d-flex align-items-center mar-top10">
                    <img src="../../assets/img/index/like.png" style="width:15px;height:15px" class="mar-right5"/>
                    <div>{{item.likeNum}}</div>
                 </div>
               </div>
             </div>

          </div>
        </div>

      </div>
      <div style="height:80px"></div>
      <div class="header"><v-footer></v-footer></div>
    </div>

    <div style="width:100%;height:100%;position: fixed;top:0;left:0;z-index:10;background:rgba(0,0,0,0.5)" v-if="layerShow" class="d-flex flex-column align-items-center justify-content-center">
        <div style="width:210px;background:#fff" class="d-flex align-items-center justify-content-center flex-column pad-left5 pad-right5 pad-top10 pad-bottom10">
          <img src="../../assets/img/index/miniProjectImg.jpg" style="width:200px;height:200px;" />
          <div class="fz14 c-333333 mar-top5">请扫码前往小程序操作</div>
          <div class="c-999999 mar-top10" style="font-size:10px">兴趣百科-再小的兴趣也是同好</div>
        </div>
        <img src="../../assets/img/index/close.png" style="width:25px;height:25px;margin-top:25px" v-on:click="lookMore(layerShow)"/>
      </div>
    </div>
  </div>

</template>

<script>
import axios from "axios";
import header from '@/pages/pc/header';
import footer from '@/pages/pc/footer';
import swiper from 'vue-awesome-swiper';
export default {
  name: 'pcDiaryDetail',
  components:{
    'v-header':header,
    'v-footer':footer
  },
  data () {
    return {
      diary:{},
      list: [],//日记列表
      layerShow:false,
      showImg:'',
      showImgIndex:0,
      swiperOptionTop: {
        effect:'fade',
        loop:false,
        loopedSlides:1,
        // zoom: true,//双击放大
        navigation: {
        	nextEl: '.swiper-button-next',
        	prevEl: '.swiper-button-prev'
        },
      },
      swiperOptionThumbs: {
        loop: false,
        loopedSlides: 1, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 9,
        touchRatio: 0.5,
        slideToClickedSlide: true
      },
    }
  },
  mounted(){//页面加载后，调用接口数据
    var diaryId = this.$route.params.id;//从列表页接受路径中的参数值
    console.log(diaryId)
    this.getData(diaryId);
  },

  updated() {
    this.$nextTick(() => {
    	// 实现swiper双向控制
    	const swiperTop = this.$refs.swiperTop.swiper
    	const swiperThumbs = this.$refs.swiperThumbs.swiper
    	swiperTop.controller.control = swiperThumbs
    	swiperThumbs.controller.control = swiperTop
    });
  },
  methods:{
    lookMore:function(param){//点击查看更多方法
      this.layerShow=!param
    },

    // toDetail:function(id){//点击日记跳转到详情页
    //   this.list=response.data.result.json.list;
    //   this.diary = response.data.result.json.entity;
    //   this.showImg = response.data.result.json.entity.diaryImgs[0].ip+response.data.result.json.entity.diaryImgs[0].url;
    // },

    //点击推荐中的日记，跳转到详情
     toDetail:function(id){
       //this.$router.push({ name: 'diaryDetail',params:{id:id}})
       this.getData(id)
     },

    //获取数据列表
    getData:function(diaryId){
      var data = {diaryid:diaryId}
      axios.post('https://www.xingqubaike.com/wx/handshake-provider-xswl-home/home/official/getDiaryDetailForH5',data).then(response => {
          this.list=response.data.result.json.list;
          this.diary = response.data.result.json.entity;
          console.log(this.diary)
          this.showImg = response.data.result.json.entity.diaryImgs[0].ip+response.data.result.json.entity.diaryImgs[0].url;
      }, response => {
          console.log("error");
      });
    },

     //点击图片显示当前图片
     selectImg:function(index){
        this.showImg = this.diary.diaryImgs[index].ip+this.diary.diaryImgs[index].url;
        this.showImgIndex=index;
     }


  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @import "../../../static/css/firstPage.css"; //直接在需要对应的vue中使用es6进行引入
  .titlePad{padding:15px 20px}
  .content{position: relative;}
  // .content .mask{position:absolute;top: 0;left:0;width:220px;border:2px solid red;  background-color:rgba(0,0,0,0.5)}
  // .content .items:hover,.content .imgbox:hover{background-color:rgba(0,0,0,0.5);cursor: pointer;}
  .listImg{width:80px;height:80px;border-radius: 10px;}
   .selectImgStyle{border:3px solid red}

   #header{background:#FFFFFF}
   #header a{color:#333333}
   #footer a{color:#666}
   #page2 #diaryList{color:#fe7f0c;border-bottom:3px solid #fe7f0c;}

    .swiper-slide {
      background-size: cover;
      background-position: center;
    }
    .gallery-top {
       height: 80%;
       width: 100%;
     }
    .gallery-thumbs {
       height: 20%;
       box-sizing: border-box;
       padding: 10px 0;
     }
    .gallery-thumbs .swiper-slide {
       width: 20%;
       height: 100%;
       opacity: 0.4;
     }
    .gallery-thumbs .swiper-slide-active {
       opacity: 1;
     }
    @media only screen and (min-device-width:900px){
       .top-img{width: 10rem;height: 10rem;}
      .slide{width: 80px !important;height: 80px !important;}
     }

     @media only screen and (max-device-width:900px){
       .header{display: none;}
       .top-img{width: 60vw;height: 60vw;margin: 0 auto}
       .slide{width: 70px !important;height: 70px !important;}
       .rightContent{
         display: none;
       }
     }

     @media only screen and (max-device-width:720px){
       .top-img{width: 94vw;height: 94vw;margin: 0 auto}
       .slide{width: 60px !important;height: 60px !important;}
       .rightContent{
         display: none;
       }
     }
     
     @media only screen and (max-width:900px){
       .header{display: none;}
       .top-img{width: 60vw;height: 60vw;margin: 0 auto}
       .slide{width: 70px !important;height: 70px !important;}
       .rightContent{
         display: none;
       }
     }
     
     @media only screen and (max-width:720px){
       .top-img{width: 94vw;height: 94vw;margin: 0 auto}
       .slide{width: 60px !important;height: 60px !important;}
       .rightContent{
         display: none;
       }
     }
</style>



// WEBPACK FOOTER //
// src/pages/pc/diaryDetail.vue